'use strict';
const observable = require('@mindmup/mapjs-core/src/util/observable');

module.exports = function CrowdlinkPageController({authenticationModel, goldFileInitialiser}) {
	if ( !authenticationModel || !goldFileInitialiser) {
		throw new Error('invalid-args');
	}
	const obj = observable(this);

	['authenticating', 'not-authenticated'].forEach(evtName => {
		authenticationModel.addEventListener(evtName, () => {
			obj.dispatchEvent(evtName);
		});
	});

	authenticationModel.addEventListener('authenticatedProfile', async () => {
		goldFileInitialiser.initFile(obj.dispatchEvent);
	});
};


